import { render } from "./ListeCouponsAdmin.vue?vue&type=template&id=9b8ec186&scoped=true&ts=true"
import script from "./ListeCouponsAdmin.vue?vue&type=script&lang=ts"
export * from "./ListeCouponsAdmin.vue?vue&type=script&lang=ts"

import "./ListeCouponsAdmin.vue?vue&type=style&index=0&id=9b8ec186&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b8ec186"]])

export default __exports__